import { render, staticRenderFns } from "./TheMessages.vue?vue&type=template&id=20e9650c&"
import script from "./TheMessages.vue?vue&type=script&lang=js&"
export * from "./TheMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports